import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { MediaItem } from '../models/message'

@Injectable({ providedIn: 'root' })
export class MediaUploadService {
  private http = inject(HttpClient);

  uploadFiles(files: File[]): Observable<MediaItem[]> {
    const formData = new FormData();
    const fileArray = Array.isArray(files) ? files : [files];
    for (const file of fileArray) {
      formData.append('files', file, file.name);
    }
    return this.http
      .post<{ statusCode: number; media_files: {
        url: string;
        filename: string;
        size: number;
        content_type: string;
        s3_key: string;
      }[] }>(
        `https://${environment.messagingApi}/media`,
        formData
      )
      .pipe(map(res =>
        res.media_files.map(f => ({
          url: f.url,
          filename: f.filename,
          size: f.size ?? 0,
          contentType: f.content_type || 'application/octet-stream',
        }))
      )
    );
  }
}
